

export class PricingTier {
  constructor() {
    this.browserPlugin = true;
    this.imageSearch = true;
    this.canTranslate = true;
  }
  name?: string;
  price?: number;
  canTranslate?: boolean;
  canAddAudio?: boolean;
  imageSearchResults?: number;
  singleClickMode?: boolean;
  browserPlugin: boolean;
  imageSearch: boolean;
  translationDailyLimit?: number;
}
